import { withTranslation } from "react-i18next";

import React from 'react';
import { Link } from 'react-router-dom';

class UserLogin extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            return (
                <div className="login_area" style={{ width: '100%' }}>
                    <Link className="override " to={"/login/buyer"}><font className="login_button">{this.props.t('0')}</font></Link>/
                    <Link className="override  " to={"/login/seller"} ><font className="login_button">{this.props.t('1')}</font></Link>
                </div>
            );
        } else {
            return (
                <ul className="justify-content-end collapse navbar-collapse" style={{ marginTop: "0px" ,paddingRight:'9px'}}>
                    <li className="nav-item" >
                        <Link className="override " to={"/login/buyer"}><font className="login_button">{this.props.t('0')}</font></Link>/
                      </li>
                    <li className="nav-item" >
                        <Link className="override  " to={"/login/seller"} ><font className="login_button">{this.props.t('1')}</font></Link>
                    </li>
                </ul>
            );
        }
    }
}

export { UserLogin };

 UserLogin = withTranslation('src_Components_Common_UserLogin')(UserLogin);